<template>
<div class="chapter">
<div class="inner_page">
<p class="p4"><span class="sz"> </span></p>
<p class="p3"><span class="sz"><b>Janet Dailey's Americana Series</b></span></p>
<p class="p4"><span class="sz"><i></i> </span></p>
<p class="p3"><span class="sz"><i>Dangerous Masquerade (Alabama)</i></span></p>
<p class="p3"><span class="sz"><i>Northern Magic (Alaska)</i></span></p>
<p class="p3"><span class="sz"><i>Sonora Sundown (Arizona)</i></span></p>
<p class="p3"><span class="sz"><i>Valley Of the Vapours (Arkansas)</i></span></p>
<p class="p3"><span class="sz"><i>Fire And Ice (California)</i></span></p>
<p class="p3"><span class="sz"><i>After the Storm (Colorado)</i></span></p>
<p class="p3"><span class="sz"><i>Difficult Decision (Connecticut)</i></span></p>
<p class="p3"><span class="sz"><i>The Matchmakers (Delaware)</i></span></p>
<p class="p3"><span class="sz"><i>Southern Nights (Florida)</i></span></p>
<p class="p3"><span class="sz"><i>Night Of The Cotillion (Georgia)</i></span></p>
<p class="p3"><span class="sz"><i>Kona Winds (Hawaii)</i></span></p>
<p class="p3"><span class="sz"><i>The Travelling Kind (Idaho)</i></span></p>
<p class="p3"><span class="sz"><i>A Lyon's Share (Illinois)</i></span></p>
<p class="p3"><span class="sz"><i>The Indy Man (Indiana)</i></span></p>
<p class="p3"><span class="sz"><i>The Homeplace (Iowa)</i></span></p>
<p class="p3"><span class="sz"><i>The Mating Season (Kansas)</i></span></p>
<p class="p3"><span class="sz"><i>Bluegrass King (Kentucky)</i></span></p>
<p class="p3"><span class="sz"><i>The Bride Of The Delta Queen (Louisiana)</i></span></p>
<p class="p3"><span class="sz"><i>Summer Mahogany (Maine)</i></span></p>
<p class="p3"><span class="sz"><i>Bed Of Grass (Maryland)</i></span></p>
<p class="p3"><span class="sz"><i>That Boston Man (Massachusetts)</i></span></p>
<p class="p3"><span class="sz"><i>Enemy In Camp (Michigan)</i></span></p>
<p class="p3"><span class="sz"><i>Giant Of Mesabi (Minnesota)</i></span></p>
<p class="p3"><span class="sz"><i>A Tradition Of Pride (Mississippi)</i></span></p>
<p class="p3"><span class="sz"><i>Show Me (Missouri)</i></span></p>
<p class="p3"><span class="sz"><i>Big Sky Country (Montana)</i></span></p>
<p class="p3"><span class="sz"><i>Boss Man From Ogallala (Nebraska)</i></span></p>
<p class="p3"><span class="sz"><i>Reilly's Woman (Nevada)</i></span></p>
<p class="p3"><span class="sz"><i>Heart Of Stone (New Hampshire)</i></span></p>
<p class="p3"><span class="sz"><i>One Of The Boys (New Jersey)</i></span></p>
<p class="p3"><span class="sz"><i>Land Of Enchantment (New Mexico)</i></span></p>
<p class="p3"><span class="sz"><i>Beware Of The Stranger (New York)</i></span></p>
<p class="p3"><span class="sz"><i>That Carolina Summer (North Carolina)</i></span></p>
<p class="p3"><span class="sz"><i>Lord Of the High Lonesome (North Dakota)</i></span></p>
<p class="p3"><span class="sz"><i>The Widow And The Wastrel (Ohio)</i></span></p>
<p class="p3"><span class="sz"><i>Six White Horses (Oklahoma)</i></span></p>
<p class="p3"><span class="sz"><i>To Tell The Truth (Oregon)</i></span></p>
<p class="p3"><span class="sz"><i>The Thawing Of Mara (Pennsylvania)</i></span></p>
<p class="p3"><span class="sz"><i>Strange Bedfellow (Rhode Island)</i></span></p>
<p class="p3"><span class="sz"><i>Low Country Liar (South Carolina)</i></span></p>
<p class="p3"><span class="sz"><i>Dakota Dreamin' (South Dakota)</i></span></p>
<p class="p3"><span class="sz"><i>Sentimental Journey (Tennessee)</i></span></p>
<p class="p3"><span class="sz"><i>Savage Land (Texas)</i></span></p>
<p class="p3"><span class="sz"><i>A Land Called Deseret (Utah)</i></span></p>
<p class="p3"><span class="sz"><i>Green Mountain Man (Vermont)</i></span></p>
<p class="p3"><span class="sz"><i>Tidewater Lover (Virginia)</i></span></p>
<p class="p3"><span class="sz"><i>For Mike's Sake (Washington)</i></span></p>
<p class="p3"><span class="sz"><i>Wild And Wonderful (West Virginia)</i></span></p>
<p class="p3"><span class="sz"><i>With A Little Luck (Wisconsin)</i></span></p>
<p class="p3"><span class="sz"><i>Darling Jenny (Wyoming)</i></span></p>
<p class="p4"><span class="sz"><i></i> </span></p>
<p class="p3"><span class="sz"><b>Other Janet Dailey Titles You Might Enjoy</b></span></p>
<p class="p5"><span class="sz"> </span></p>
<p class="p3"><span class="sz"><i>American Dreams</i></span></p>
<p class="p3"><span class="sz"><i>Aspen Gold</i></span></p>
<p class="p3"><span class="sz"><i>Fiesta San Antonio</i></span></p>
<p class="p3"><span class="sz"><i>For Bitter Or Worse</i></span></p>
<p class="p3"><span class="sz"><i>The Great Alone</i></span></p>
<p class="p3"><span class="sz"><i>Heiress</i></span></p>
<p class="p3"><span class="sz"><i>The Ivory Cane</i></span></p>
<p class="p3"><span class="sz"><i>Legacies</i></span></p>
<p class="p3"><span class="sz"><i>Masquerade</i></span></p>
<p class="p3"><span class="sz"><i>The Master Fiddler</i></span></p>
<p class="p3"><span class="sz"><i>No Quarter Asked</i></span></p>
<p class="p3"><span class="sz"><i>Rivals</i></span></p>
<p class="p3"><span class="sz"><i>Something Extra</i></span></p>
<p class="p3"><span class="sz"><i>Sweet Promise</i></span></p>
<p class="p3"><span class="sz"><i>Tangled Vines</i></span></p>
<p class="p2"><span class="sz"> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section2.vue?a2f6b4cc